<script setup lang="ts">

import { faCalendar, faCalendarCircleExclamation, faCalendarCircleMinus, faCircleInfo } from '@fortawesome/pro-regular-svg-icons'

import { AppText } from '@shared/ui/typography'
import { AppTooltip } from '@shared/ui/tooltips'
import { AppIcon } from '@shared/ui/icons'

import { DisciplineAllocationStatus } from '../model/enums'

defineOptions({
  name: 'DisciplineScheduleAvailability',
})

defineProps<{
  status: DisciplineAllocationStatus
  label: string
  tooltip: string
}>()

const ICONS = {
  [DisciplineAllocationStatus.Available]: faCalendar,
  [DisciplineAllocationStatus.PartlyAvailable]: faCalendarCircleExclamation,
  [DisciplineAllocationStatus.Busy]: faCalendarCircleMinus,
}
</script>

<template>
  <div :class="['discipline-schedule-availability', status]">
    <AppIcon
      :icon="ICONS[status]"
      size="small"
    />
    <AppText
      name="body2"
      class="discipline-schedule-availability__text"
    >
      {{ label }}
    </AppText>
    <AppTooltip
      :text="tooltip"
      size="small"
    >
      <AppIcon
        :icon="faCircleInfo"
        size="small"
        color="slate-500"
      />
    </AppTooltip>
  </div>
</template>

<style scoped lang="scss" src="./DisciplineScheduleAvailability.scss" />
